import { useState, useEffect } from "react";
import { Lock } from "lucide-react";

const verify = async (code) => {
  const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/access`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ code, path: window.location.pathname }),
  });
  const data = await res.json();
  return !!data.ok;
};

let autoTried = false;

const PUBLIC_PATHS = ["/", "/events", "/v2", "/live-mozzarella-experience", "/luxury-wedding-events-show-cooking", "/dossier"];

export const AccessGate = ({ children }) => {
  const isPublic = PUBLIC_PATHS.includes(window.location.pathname.replace(/\/+$/, "") || "/");
  const [granted, setGranted] = useState(() => isPublic || sessionStorage.getItem("filata-access") === "granted");
  const [code, setCode] = useState("");
  const [err, setErr] = useState(false);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (autoTried) return;
    const k = new URLSearchParams(window.location.search).get("k");
    if (!k) return;
    if (!isPublic && granted) return;
    autoTried = true;
    verify(k).then((ok) => {
      if (ok) {
        sessionStorage.setItem("filata-access", "granted");
        sessionStorage.setItem("filata-code", k);
        setGranted(true);
      }
    }).catch(() => {});
  }, [granted, isPublic]);

  if (granted) return children;

  const submit = async (e) => {
    e.preventDefault();
    if (!code.trim() || busy) return;
    setBusy(true);
    setErr(false);
    try {
      if (await verify(code)) {
        sessionStorage.setItem("filata-access", "granted");
        sessionStorage.setItem("filata-code", code.trim());
        setGranted(true);
      } else {
        setErr(true);
      }
    } catch {
      setErr(true);
    }
    setBusy(false);
  };

  return (
    <div className="min-h-screen bg-wine text-bg flex items-center justify-center px-6" data-testid="access-gate">
      <div className="w-full max-w-sm text-center">
        <p className="font-serif text-5xl mb-2">Filata<span className="text-terracotta">.</span></p>
        <p className="font-sans text-[11px] uppercase tracking-[0.3em] text-bg/50 mb-10">
          Private Presentation · Presentazione Privata
        </p>
        <form onSubmit={submit} className="space-y-6">
          <div className="relative">
            <Lock className="absolute left-0 top-1/2 -translate-y-1/2 h-4 w-4 text-bg/40" strokeWidth={1.75} />
            <input
              data-testid="access-code-input"
              type="password"
              autoFocus
              placeholder="Access code · Codice di accesso"
              value={code}
              onChange={(e) => { setCode(e.target.value); setErr(false); }}
              className="w-full bg-transparent border-b border-bg/25 py-3 pl-7 font-sans text-bg placeholder:text-bg/35 focus:outline-none focus:border-terracotta transition-colors"
            />
          </div>
          {err && (
            <p data-testid="access-error" className="font-sans text-sm text-terracotta">
              Invalid code · Codice non valido
            </p>
          )}
          <button
            data-testid="access-submit"
            type="submit"
            disabled={busy}
            className="w-full rounded-full bg-terracotta px-8 py-3.5 text-sm font-sans tracking-wide text-white hover:bg-terracotta/90 transition-colors disabled:opacity-60"
          >
            {busy ? "…" : "Enter · Entra"}
          </button>
        </form>
        <p className="font-sans text-[11px] text-bg/30 mt-10">By invitation only · Solo su invito</p>
      </div>
    </div>
  );
};
